"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Footer = void 0;
const react_1 = __importDefault(require("react"));
const colors_1 = require("../../../theme/colors");
const icons_1 = require("../../../theme/icons");
const Footer_styles_1 = require("./Footer.styles");
const Footer = ({ children, informationText, informationLinkUrl, informationLinkText, versionText, }) => {
    return (react_1.default.createElement(Footer_styles_1.FooterWrapper, null,
        react_1.default.createElement(Footer_styles_1.ContentWrapper, null,
            children,
            react_1.default.createElement(Footer_styles_1.InformationText, null,
                informationText,
                informationLinkUrl && (react_1.default.createElement(Footer_styles_1.InformationLink, { href: informationLinkUrl, target: "_blank", rel: "noreferrer noopener" },
                    informationLinkText,
                    " ",
                    react_1.default.createElement(icons_1.Launch, { color: colors_1.SWEGON_GREEN, size: "small" }))),
                react_1.default.createElement(Footer_styles_1.VersionText, null, versionText)))));
};
exports.Footer = Footer;
//# sourceMappingURL=Footer.js.map